import { Spacings } from '@picsart/cascade';
import { ControlSizesLG, InlineButton } from '@picsart/inlineButton';
import IconZoomIn from '@picsart/icons/IconZoomIn';
import IconZoomOut from '@picsart/icons/IconZoomOut';
import View from '@picsart/view/View';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';

import usePreviewModal from '../usePreviewModal';

const PreviewModalZoomDesktopActions = () => {
  const { isWeb } = useBatchData();
  const { onZoomIn, onZoomOut } = usePreviewModal();
  if (!isWeb) return null;

  return (
    <View columnGap={Spacings.s16} padding={Spacings.s16} paddingBlockStart={Spacings.s0} justifyContent="center">
      <InlineButton centerIcon={IconZoomIn} size={ControlSizesLG} onClick={onZoomIn} />
      <InlineButton centerIcon={IconZoomOut} size={ControlSizesLG} onClick={onZoomOut} />
    </View>
  );
};

export default PreviewModalZoomDesktopActions;
